"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackElements = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const merge_1 = require("merge");
const index_styles_1 = require("./index.styles");
const StackElements = ({ spacing = 0, gap = undefined, alignItems = 'flex-start', justifyContent = 'flex-start', direction = 'row', children, style, className = undefined, }) => {
    const styles = (0, index_styles_1.useStackElementsStyles)({ spacing, gap, alignItems, justifyContent, direction });
    return ((0, jsx_runtime_1.jsx)("div", { style: (0, merge_1.merge)(style, styles.stack), className: className, children: children }));
};
exports.StackElements = StackElements;
